import { Tab, TabList, Tabs } from '@wartek-id/tabs'

import type { TabFilterRoles } from 'types/kinerja-ks'
import type { FC } from 'react'

export type TabsKsTabDetail = { name: TabFilterRoles | string; index: number }

export type TabKsDefinitifPltGuruProps = {
  defaultIndex?: number
  counters?: Record<TabFilterRoles | string, number>
  onChange?: (props: TabsKsTabDetail) => void
}

// Return tab detail based on index
export const getTabDetail = (index: number): TabsKsTabDetail => {
  if (index === 1) return { name: 'KS_PLT', index }
  if (index === 2) return { name: 'GURU', index }
  return { name: 'KS', index }
}

const TabKsDefinitifPltGuru: FC<TabKsDefinitifPltGuruProps> = ({
  defaultIndex = 0,
  counters,
  onChange,
}) => {
  const showCounter = !!counters
  return (
    <Tabs
      defaultIndex={defaultIndex}
      onChange={(index) => onChange?.(getTabDetail(index))}
      className="w-full"
    >
      <TabList
        className="justify-evenly"
        style={{ boxShadow: '0px 2px 1px 0px #0000000D' }}
      >
        <Tab tabIndex={0}>
          Kepala Sekolah Definitif {showCounter && `(${counters?.KS || 0})`}
        </Tab>
        <Tab tabIndex={1}>
          Plt. Kepala Sekolah {showCounter && `(${counters?.PLT_KS || 0})`}
        </Tab>
        <Tab tabIndex={2}>Guru {showCounter && `(${counters?.GURU || 0})`}</Tab>
      </TabList>
    </Tabs>
  )
}

export default TabKsDefinitifPltGuru
